import { RootState } from "@/store"
import { UserInfo as UserInfoComponent } from "@gisce/oficina-virtual-components"
import { useSelector } from "react-redux"

export const UserInfo = () => {
	const {data, isFetching} = useSelector((state: RootState) => state.profile);

	return data ? <UserInfoComponent 
		avatarPosition="left" 
		email={data.email}
		name={data.name}
		loading={isFetching}
	/> : <></>
}
